import { dateFormatter } from 'zens-storybook'

import { Model, ModelData } from '../general'

export interface Data extends ModelData {
  company_id: number
  workspace_id?: number
  product_id?: number
  comment: string
  created_at?: string
}

class Comment extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }
  get workspaceId() {
    return this.data.workspace_id
  }
  get productId() {
    return this.data.product_id
  }
  get text() {
    return this.data.comment
  }
  get createdAt() {
    if (!this.data.created_at) return undefined
    return new Date(this.data.created_at)
  }
  get displayCreatedAt() {
    const { i18n } = this.store
    return this.data.created_at ? dateFormatter(this.data.created_at, 'PPPp', i18n.language) : ''
  }
}

export default Comment
